import { useSelector } from "react-redux";

import { getTenantConfig } from "ee/selectors/tenantSelectors";
import { useLayoutEffect } from "react";
import { getAppsmithConfigs } from "ee/configs";
const { inCloudOS } = getAppsmithConfigs();
import { getAssetUrl } from "ee/utils/airgapHelpers";
import { APPSMITH_BRAND_PRIMARY_COLOR } from "utils/BrandingUtils";
import { LightModeTheme } from "@design-system/theming";

const useBrandingTheme = () => {
  const config = useSelector(getTenantConfig);
  let activeColor: string | undefined = undefined;
  if (
    config.brandColors.primary !== undefined &&
    (config.brandColors.active === undefined ||
      config.brandColors.active === "")
  ) {
    // 检查主色是否为渐变色 - 如果是则提取第一个颜色
    let primaryColor = config.brandColors.primary;
    if (primaryColor.includes("gradient")) {
      // 从渐变字符串中提取第一个颜色
      const match = primaryColor.match(/rgb\((\d+),(\d+),(\d+)\)/);
      if (match) {
        const [, r, g, b] = match;
        primaryColor = `rgb(${r}, ${g}, ${b})`;
      } else {
        // 如果渐变解析失败则使用默认颜色
        primaryColor = APPSMITH_BRAND_PRIMARY_COLOR;
      }
    }

    const lightTheme = new LightModeTheme(primaryColor);
    activeColor =
      config.brandColors.primary === APPSMITH_BRAND_PRIMARY_COLOR
        ? getComputedStyle(document.documentElement).getPropertyValue(
            "--ads-v2-color-bg-brand-emphasis-plus",
          )
        : lightTheme.bgAccentActive.toString({ format: "hex" });
  }

  useLayoutEffect(() => {
    const cssVariables: Record<string, string> = {
      "bg-brand": config.brandColors.primary,
      "fg-brand": config.brandColors.primary,
      "border-brand": config.brandColors.primary,
      // TODO:(Albin) Remove this once branding and new DS is fully integrated
      "background-secondary": config.brandColors.background,
      "bg-brand-emphasis": config.brandColors.hover,
      "bg-brand-emphasis-plus": activeColor || config.brandColors.active,
      "fg-brand-emphasis": config.brandColors.hover,
      "border-brand-emphasis": config.brandColors.hover,
      "border-brand-emphasis-plus": activeColor || config.brandColors.active,
      "fg-on-brand": config.brandColors.font,
    };

    // Create a CSS variable for each color
    for (let i = 0; i < Object.keys(cssVariables).length; i++) {
      const key = Object.keys(cssVariables)[i];
      const value = Object.values(cssVariables)[i];
      const prefix =
        key === "background-secondary" ? "--ads-color-" : "--ads-v2-color-";

      document.documentElement.style.setProperty(`${prefix}${key}`, value);
    }
    // 设置选中样式专用变量，不影响其他使用 --ads-color-brand 的地方
    const primaryColor = config.brandColors.primary;
    const hasGradient = primaryColor.includes("gradient");
    
    let selectionBackground = primaryColor;
    let selectionTextColor = config.brandColors.font;
    
    if (hasGradient) {
      selectionBackground = "#27b7b7";
      selectionTextColor = "#fff";
    }
    
    document.documentElement.style.setProperty("--ads-color-brand-selection", selectionBackground);
    document.documentElement.style.setProperty("--ads-color-brand-text-selection", selectionTextColor);
    document.documentElement.style.setProperty("--ads-color-brand-tab-selection", primaryColor);


    if (inCloudOS) {
      return;
    }
    // Set the favicon
    let favicon: any = document.querySelector("link[rel='shortcut icon']");
    if (!favicon) {
      favicon = document.createElement("link");
      favicon.rel = "shortcut icon";
      favicon.className = "t--branding-favicon";
      document.getElementsByTagName("head")[0].appendChild(favicon);
    }

    favicon.href = config.brandFaviconUrl;
  }, [
    config.brandColors.primary,
    config.brandColors.background,
    config.brandColors.hover,
    config.brandColors.font,
    config.brandColors.disabled,
    config.brandFaviconUrl,
  ]);
};

export default useBrandingTheme;
